import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="mt-24 border-t-2 border-[#E6DEC6] bg-[#F2EBE1]" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:px-8 md:grid-cols-3">
      <div>
        <p className="font-serif text-2xl font-bold text-[#4A2A18]">Voices 2 Remember</p>
        <p className="font-script mt-1 text-2xl text-[#A83232]">Your voice. Your stories. Their keepsake.</p>
      </div>
      <div className="space-y-2 text-[#5C4A3E]">
        <p className="font-semibold text-[#2C1E16]">Privacy & removal</p>
        <p>Videos are uploaded to YouTube as <b>unlisted</b>: anyone with the link or sticker can watch and share them.</p>
        <p>To remove a video, open your keepsake in <Link className="font-semibold text-[#A83232] underline" to="/orders" data-testid="footer-orders-link">My keepsakes</Link>. Removing it stops printed QR codes from playing it.</p>
      </div>
      <div className="space-y-2 text-[#5C4A3E]">
        <p className="font-semibold text-[#2C1E16]">Watch us on YouTube</p>
        <a href="https://www.youtube.com/@voicestoremember" target="_blank" rel="noreferrer" className="font-semibold text-[#A83232] underline" data-testid="footer-youtube-link">@voicestoremember</a>
        <p><Link className="font-semibold text-[#A83232] underline" to="/affiliates" data-testid="footer-affiliates-link">Become an affiliate</Link>: earn $5 for every family you refer.</p>
        <p className="text-sm">QR stickers and holiday ornaments. FREE standard shipping to the lower 48 states.</p>
        <p className="flex flex-wrap gap-x-5 gap-y-2 text-base">
          <Link className="font-semibold text-[#A83232] underline" to="/terms" data-testid="footer-terms-link">Terms & Conditions</Link>
          <Link className="font-semibold text-[#A83232] underline" to="/privacy" data-testid="footer-privacy-link">Privacy Policy</Link>
        </p>
        <p className="text-base">Questions? <a className="underline" href="mailto:info@voices2remember.com" data-testid="footer-contact-email">info@voices2remember.com</a></p>
      </div>
    </div>
  </footer>
);
